import React, {FC} from 'react';

import {MainInfo} from '../components';

const HomePage: FC = () => {
   return (
      <MainInfo/>
   );
};

export {HomePage};